export class ModelLog {
  constructor () {
    const currentEmployee = window.app.$store.getters.get('currentEmployee')

    this.id = null
    this.repairExchangeOrderFollowUpID = null
    this.entryDate = new Date()
    this.employeeID = currentEmployee.id
    this.description = ''
    this.isEmployeeEntry = true
    this.isRead = false
  }
}
export class RepairExchangeOrderFollowUp {
  partID = null
  baxpo = ''
  partSN = ''
}
